[
    {
        "name": "Mr. Vincent Gim",
        "bio": "Vincent Gim is a generalist software engineer with 9 years of experience in the industry. He has worked mainly as a full stack web developer before moving to his current team that builds and supports machine learning workflows. He is now a Software Development Engineer at Amazon.",
        "image": "https://data.vhackusm.com/mentors/1hv4VTAa88hyBFMWY50j0N_2Fne8AKy8g.jpg",
        "business": 1,
        "technical": 1,
        "linkedin": "https://www.linkedin.com/in/vincent-gim/"
    },
    {
        "name": "Mr. Nazreen Mohamad",
        "bio": "Nazreen Mohamad is a software engineer and technical instructor. Having gone through the self-taught journey in programming, he has run initiatives such as Stack School that provided introductory programming classes to the public. He is currently a software engineer at Amazon Web Services in the UK. ",
        "image": "https://data.vhackusm.com/mentors/1RNK8rzYJjVYv5hnEJm0ZHERtdzMp0TKi.jpg",
        "business": 1,
        "technical": 1,
        "linkedin": "https://www.linkedin.com/in/nazreenmohamad/"
    },
    {
        "name": "Mr. Melvin Ch'ng ",
        "bio": "Melvin Ch'ng is a Technical Product Business Owner at Dell. He spent the last 3 years working at a B2B MarTech startup. He has designed, developed, and deployed various scalable SaaS consumer insights solutions and data collection tools.",
        "image": "https://data.vhackusm.com/mentors/1S5DxajZ1IJcVqjD178XY9Jpmr-cEPnYc.jpg",
        "business": 1,
        "technical": 1,
        "linkedin": "https://www.linkedin.com/in/realmelvinchng/"
    },
    {
        "name": "Mr. Yudhishthra Sugumaran ",
        "bio": "Yudhishthra Sugumaran is a software engineering student and a hackathon hacker with a focus on building products that matter. This focus led him to participate in 7 hackathons to date while receiving 4 awards and in-depth experience. ",
        "image": "https://data.vhackusm.com/mentors/1LnbV_JKzIt-iheYpTyhMMtFFPCdqh0Zl2.jpg",
        "business": 1,
        "technical": 1,
        "linkedin": "https://www.linkedin.com/in/yudhishthra/"
    },
    {
        "name": "BinHong Lee",
        "bio": "BinHong Lee is a software engineer at Meta Inc. currently based in the Bay Area, California. He has had experience working on many different parts of the stack and was actively involved in startups in the earlier part of his life. He has also mentored, judged, and spoken at multiple hackathons previously and would be happy to be to provide any help necessary.",
        "image": "https://data.vhackusm.com/mentors/1umG76jXCQiyKXWiYAKSzj-lFApUIH7WH.jpg",
        "business": 1,
        "technical": 1,
        "linkedin": "https://www.linkedin.com/in/binhonglee/"
    }
]
